<template>
	<div class="main">
		<el-container style="height: 100%; padding: 60px 0 0 ;">
			<el-header style="background: #515A6E; line-height: 60px; position: fixed; top: 0; left: 0; width: 100%; z-index: 1987;">
				<div class="flex justify-between  align-center">
					<div style="font-size: x-large; color: white;">
						{{ $cfg.name }}
						<sup class="text-sm">v{{ $cfg.version }}</sup>
					</div>
					<el-dropdown trigger="click" @command="clickDropdown">
						<span class="el-dropdown-link text-white">
							<div class="flex justify-between align-center">
								<el-avatar :src="user.profile.avatar" v-if="user.profile.avatar"></el-avatar>
								<el-avatar icon="el-icon-user-solid" v-else></el-avatar>
								<div class="padding-lr-sm flex align-center">
									<div class="padding-right">
										<div style="line-height: 25px;">
											<span class="text-white text-lg">{{ user.profile.name }}</span>
										</div>
										<div style="line-height: 20px;">
											<span class="cu-tag sm bg-blue light radius">{{ user.profile.position }}</span>
										</div>
									</div>
									<i class="el-icon-arrow-down el-icon--right"></i>
								</div>
							</div>
						</span>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item command="userinfo">个人资料</el-dropdown-item>
							<el-dropdown-item command="dialogFormVisible" divided>修改密码</el-dropdown-item>
							<el-dropdown-item divided command="loginout">退出登陆</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</div>
			</el-header>
			<el-container class="cbody">
				<el-aside style="background-color: #515A6E; height: 100%; width: auto; position: relative;">
					<el-menu
						:default-active="$route.meta.navIndex"
						unique-opened
						router
						background-color="#515A6E"
						text-color="#fff"
						active-text-color="#409eff"
						class="el-menu-vertical-demo"
						:collapse="isCollapse"
						style="height: 100%;"
					>
						<el-submenu index="4">
							<template slot="title">
								<i class="iconfont-kehu"></i>
								<span>客户关系</span>
							</template>
							<el-menu-item index="4-1" :route="{}">
								<i class="iconfont-xiansuo"></i>
								<span>线索</span>
							</el-menu-item>
							<el-menu-item index="4-2" :route="{}">
								<i class="iconfont-shangji"></i>
								<span>商机</span>
							</el-menu-item>
							<el-menu-item index="4-3" :route="{ path: '/crm/customer' }">
								<i class="iconfont-kehu"></i>
								<span>客户</span>
							</el-menu-item>
							<el-menu-item index="4-4" :route="{ path: '/crm/contacter' }">
								<i class="iconfont-lianxiren"></i>
								<span>联系人</span>
							</el-menu-item>
						</el-submenu>
						<el-submenu index="3">
							<template slot="title">
								<i class="iconfont-hetong"></i>
								<span>合同</span>
							</template>
							<el-menu-item index="3-9" :route="{ path: '/contract/class' }">
								<i class="el-icon-caret-right"></i>
								<span>分类</span>
							</el-menu-item>
							<el-menu-item index="3-1" :route="{ path: '/contract/archive/list' }">
								<i class="el-icon-caret-right"></i>
								<span>档案</span>
							</el-menu-item>
						</el-submenu>
						<el-submenu index="5">
							<template slot="title">
								<i class="iconfont-dingdan"></i>
								<span>订单</span>
							</template>
							<el-menu-item index="5-1" :route="{ path: '/order/list' }">
								<i class="iconfont-dingdan"></i>
								<span>订单</span>
							</el-menu-item>
						</el-submenu>
						<el-submenu index="6">
							<template slot="title">
								<i class="iconfont-fuwu"></i>
								<span>服务</span>
							</template>
							<el-menu-item index="6-1" :route="{ path: '/service/list' }">
								<i class="el-icon-caret-right"></i>
								<span>服务列表</span>
							</el-menu-item>
							<el-menu-item index="6-6" :route="{ path: '/service/dljz/list' }">
								<i class="el-icon-caret-right"></i>
								<span>代账</span>
							</el-menu-item>
						</el-submenu>
						<el-menu-item index="7-1" :route="{ path: '/workorder/list' }">
							<i class="iconfont-renwu"></i>
							<span>工单</span>
						</el-menu-item>
						<el-submenu index="8">
							<template slot="title">
								<i class="iconfont-caiwu"></i>
								<span>财务</span>
							</template>
							<el-menu-item index="8-1" :route="{ path: '/finance/receivable' }">
								<i class="el-icon-caret-right"></i>
								<span>应收款</span>
							</el-menu-item>
							<el-menu-item index="8-2" :route="{ path: '/finance/receipt' }">
								<i class="el-icon-caret-right"></i>
								<span>收款单</span>
							</el-menu-item>
						</el-submenu>
						<el-submenu index="9">
							<template slot="title">
								<i class="iconfont-renshi"></i>
								<span>人事</span>
							</template>
							<el-menu-item index="9-1" :route="{ path: '/hr/department' }">
								<i class="el-icon-caret-right"></i>
								<span>组织架构</span>
							</el-menu-item>
							<el-menu-item index="9-2" :route="{ path: '/hr/department/dingTalk' }">
								<i class="el-icon-caret-right"></i>
								<span>钉钉同步</span>
							</el-menu-item>
							<el-menu-item index="9-3" :route="{ path: '/hr/department/qywx' }">
								<i class="el-icon-caret-right"></i>
								<span>企业微信同步</span>
							</el-menu-item>
						</el-submenu>
						<el-submenu index="99">
							<template slot="title">
								<i class="iconfont-xitong"></i>
								<span>系统</span>
							</template>
							<el-menu-item index="99-1" :route="{ path: '/manager/product/' }">
								<i class="el-icon-caret-right"></i>
								<span>产品管理</span>
							</el-menu-item>
							<el-menu-item index="99-2" :route="{ path: '/manager/user/' }">
								<i class="el-icon-caret-right"></i>
								<span>账号管理</span>
							</el-menu-item>
							<el-menu-item index="99-9" :route="{ path: '/manager/setting/sms' }">
								<i class="el-icon-caret-right"></i>
								<span>账户记录</span>
							</el-menu-item>
						</el-submenu>
					</el-menu>
					<div class="" style="position: absolute; bottom: 15px; right: 15px;">
						<el-tag type="info" effect="dark" @click="changeCollapse">
							<i class="el-icon-d-arrow-right" v-if="isCollapse"></i>
							<i class="el-icon-d-arrow-left" v-else></i>
						</el-tag>
					</div>
				</el-aside>
				<el-main style="background: #f5f5f5; height: 100%;"><router-view></router-view></el-main>
			</el-container>
		</el-container>
		<el-dialog :visible.sync="dialogFormVisible" width="400px" :close-on-click-modal="false">
			<div slot="title">
				<span class="el-icon-key"></span>
				<span class="">修改密码</span>
			</div>
			<div v-loading="loadingChangePass">
				<el-form ref="formChangePass" :model="formChangePass" label-width="80px">
					<el-form-item label="新密码" prop="newpass" :rules="{ required: true, message: '请填写新密码', trigger: 'blur' }">
						<el-input v-model="formChangePass.newpass" autocomplete="off"></el-input>
					</el-form-item>
					<el-form-item label="再次输入" prop="newpass_check" :rules="{ required: true, message: '请再次填写新密码', trigger: 'blur' }">
						<el-input v-model="formChangePass.newpass_check" autocomplete="off"></el-input>
					</el-form-item>
					<el-divider></el-divider>
					<el-form-item>
						<el-button type="primary" @click="formSubmitChangePass('formChangePass')">确 定</el-button>
						<el-button @click="dialogFormVisible = false">取 消</el-button>
					</el-form-item>
				</el-form>
			</div>
		</el-dialog>
	</div>
</template>

<script>
export default {
	data() {
		return {
			dialogFormVisible: false,
			loadingChangePass: false,
			isCollapse: false,
			user: {
				agent: {},
				profile: {}
			},
			formChangePass: {
				newpass: '',
				newpass_check: ''
			}
		};
	},
	beforecreate: function() {},
	created: function() {
		const loading = this.$loading({
			lock: true,
			text: '处理中...',
			background: 'rgba(0, 0, 0, 0.7)'
		});
		this.$http.post('/server/index.php?m=user/index&a=getinfo', {}).then(
			res => {
				loading.close();
				if (res.result == 'ok') {
					this.user = res.data.user;
				} else {
					this.$alert(res.msg, { title: '操作错误', type: 'error' });
				}
			},
			r => {
				loading.close();
				this.$alert('网络错误，指定的服务无法访问。', { title: '系统错误', type: 'error' });
			}
		);
	},
	mounted: function() {},
	updated: function() {},
	methods: {
		changeCollapse() {
			this.isCollapse = !this.isCollapse;
		},
		clickDropdown(command) {
			if (command == 'loginout') {
				this.$confirm('确定要退出？', {
					title: '操作确认',
					type: 'warning',
					callback: r => {
						if (r == 'confirm') {
							this.$store.commit('LOGIN_OUT');
						}
					}
				});
			} else if (command == 'dialogFormVisible') {
				this.dialogFormVisible = true;
			} else if (command == 'userinfo') {
				this.$router.push({
					path: '/user'
				});
			}
		},
		formSubmitChangePass(formName) {
			this.$refs[formName].validate(valid => {
				if (valid) {
					this.loadingChangePass = true;
					this.$http.post('/server/index.php?m=user/index&a=changepass', formChangePass).then(
						res => {
							this.loadingChangePass = false;
							if (res.result == 'ok') {
								this.$alert('您的密码已修改，下次请使用新密码登陆系统！', {
									type: 'success',
									title: '操作成功',
									callback: () => {
										this.dialogFormVisible = false;
									}
								});
							} else {
								this.$alert(res.msg, { title: '操作错误', type: 'error' });
							}
						},
						r => {
							this.loadingChangePass = false;
							this.$alert('网络错误，指定的服务无法访问。', { title: '系统错误', type: 'error' });
						}
					);
				} else {
					console.log('error submit!!');
					return false;
				}
			});
		}
	}
};
</script>

<style>
.el-main {
	padding: 0;
}
.cbody {
	position: relative;
	height: calc(100vh - 60px);
}
.el-menu {
	width: 192px;
}
.el-menu--collapse {
	width: 64px !important;
}
.el-submenu .el-menu-item {
	padding-left: 30px;
	padding-right: 0;
	min-width: 128px;
}
</style>
